import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import DocumentLinksDialog, {
  documentLinkTypes,
  folderNames,
} from '../document-links-dialog';
import { ItemAPI } from '../../../api/item';
import { useP21UserContext } from '../../../context/p21-user-context';

function ItemDocumentLinks({ itemId }) {
  const { permissions } = useP21UserContext();

  const [showFiles, setShowFiles] = useState(false);
  const [documentCache, setDocumentCache] = useState(undefined);

  const getDocumentLinks = async (skipCache = false) => {
    // A skipCache is required because of how React
    // batches updates. If we just use setDocumentCache(undefined)
    // that doesn't run until AFTER this is evaluted.
    // See the useEffect on line 31 for more info.
    if (documentCache && !skipCache) {
      return documentCache;
    }
    const { data: documentLinks } = await ItemAPI.getDocumentLinks({
      itemId,
    });
    setDocumentCache(documentLinks);
    return documentLinks;
  };

  useEffect(() => {
    setDocumentCache(undefined);
    const getDocLinks = async () => {
      try {
        await getDocumentLinks(true);
      } catch {
        console.error('Could not load documents');
      }
    };
    getDocLinks();
  }, [itemId]);

  const addDocumentLinks = async ({
    newDocumentLinks,
    updatedDocumentLinks,
  }) => {
    await ItemAPI.addDocumentLinks({
      updatedDocumentLinks,
      newDocumentLinks,
      itemId,
    });
    setDocumentCache(undefined);
  };

  const viewDocumentLinksFile = async ({ rowIndex }) => {
    const { data: blob } = await ItemAPI.viewDocumentLinksFile({
      rowIndex,
      itemId,
    });
    return blob;
  };

  const title = `Manage ${documentCache?.length ?? '-'} Item Files`;

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        onClick={() => {
          setShowFiles(true);
        }}
      >
        {title}
      </Button>
      <DocumentLinksDialog
        defaultTitle={title}
        documentLinkType={documentLinkTypes.item}
        entityType='item'
        entityId={itemId}
        show={showFiles}
        setShow={setShowFiles}
        getDocumentLinks={getDocumentLinks}
        addDocumentLinks={addDocumentLinks}
        viewDocumentLinksFile={viewDocumentLinksFile}
        linkGroupsRequireExpiration={[folderNames.vendorQuotes]}
        allowedLinkGroups={
          permissions.isSupplyChain ? [] : [folderNames.vendorQuotes]
        }
      />
    </>
  );
}

export default ItemDocumentLinks;
